import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { METRIC_LABELS as BASE_METRIC_LABELS } from '../lib/hardware/hardwareCatalog'
import type { TelemetryMetric } from '../lib/hardware/types'

export function useHardwareMetricLabels() {
  const { t } = useTranslation()

  const labelFor = useCallback(
    (metric: TelemetryMetric) => ({
      label: t(`workout.metrics.${metric}.label`, { defaultValue: BASE_METRIC_LABELS[metric]?.label ?? metric }),
      unit: t(`workout.metrics.${metric}.unit`, { defaultValue: BASE_METRIC_LABELS[metric]?.unit ?? '' }),
    }),
    [t],
  )

  const metricLabels = useMemo(() => {
    const map = {} as Record<TelemetryMetric, { label: string; unit: string }>
    for (const key of Object.keys(BASE_METRIC_LABELS) as TelemetryMetric[]) {
      map[key] = labelFor(key)
    }
    return map
  }, [labelFor])

  return { labelFor, metricLabels }
}
